<div *ngIf="offer" class="offer-card-container">
    <div class="offer-card" [class.disabled]="!offer.canEdit">
        <!-- Loading indicator -->
        <div class="offer-loading-indicator" *ngIf="isPerformingAction">
            <div class="spinner"></div>
            <span>{{ getLoadingText() }}</span>
        </div>

        <div class="offer-header">
            <div class="offer-info">
                <div class="offer-meta1">
                    <h3 class="offer-title">
                        <img src="./assets/images/icons/book_mark.png" alt="book_mark">
                        <span>{{ offer.price | priceFormat }}</span>
                    </h3>
                    <span class="creation-date">
                        {{ offer.createdAt }}
                    </span>
                </div>
                <div class="offer-meta2">
                    <div class="status-badge">
                        <span class="status-dot" [ngClass]="getOfferStatusClass()"></span>
                        <span class="status-text">{{ getOfferStatusText() }}</span>
                    </div>

                    <!-- Action buttons for pending offers -->
                    <div class="offer-action-buttons" *ngIf="canAcceptOffer() && !isPerformingAction">
                        <button class="action-btn accept-btn" [title]="getActionButtonText('accept')" (click)="acceptOffer()">
                            <img src="./assets/images/icons/check-circle.svg" alt="Accept">
                            <span>{{ getActionButtonText('accept') }}</span>
                        </button>

                        <button *ngIf="canRejectOffer() && !isPerformingAction" class="action-btn reject-btn" [title]="getActionButtonText('reject')" (click)="rejectOffer()">
                            <img src="./assets/images/icons/x-circle.svg" alt="Reject">
                            <span>{{ getActionButtonText('reject') }}</span>
                        </button>
                    </div>

                    <!--<button *ngIf="canRejectOffer() && !isPerformingAction" class="card-menu-btn" type="button" (click)="toggleMenu($event)">
                        <img src="./assets/images/icons/menu-drop.png" alt="menu" class="menu-icon">
                    </button>-->
                </div>
            </div>
        </div>

        <div class="offer-note">
            <p>{{ offer.description }}</p>
        </div>

        <div class="offer-content">
            <div class="agents-section">
                <div *ngIf="!offer.agents || offer.agents.length === 0" class="no-agents">
                    <p>Aucun agent assigné</p>
                </div>

                <div *ngIf="offer.agents && offer.agents.length > 0" class="agents-list">
                    <div class="agents-list-header" (click)="toggleAgentsList($event)">
                        <img src="./assets/images/icons/user_check_gray.png" alt="user check icon">
                        <span>Agents assigner ( <strong>{{offer.agents.length}}</strong> )</span>
                        <img src="./assets/images/icons/arrow-down.png" alt="arrow down icon" class="arrow-icon" [@rotateArrow]="isAgentsExpanded ? 'open' : 'closed'">
                    </div>

                    <div class="agents-chips-container" [@slideInOut]="isAgentsExpanded ? 'open' : 'closed'">
                        <div *ngFor="let agent of offer.agents" class="agent-chip">
                            <div class="agent-image-col">
                                <img [src]="agent.profileImage || './assets/images/icons/user-default-icon.png'" [alt]="agent.firstName" class="agent-image" [class.full]="agent.profileImage">
                            </div>
                            <div class="agent-content-col">
                                <span class="agent-name">{{ agent.firstName }} {{ agent.lastName }}</span>
                                <div class="agent-info">
                                    <span class="agent-email">{{ agent.email }}</span>
                                    <span class="agent-age" *ngIf="agent.age">{{ agent.age }} ans</span>
                                    <span class="agent-height" *ngIf="agent.height">{{ agent.height }} cm</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Offer Menu Dropdown -->
    <!--<div class="popup-menu" *ngIf="menuOpen && canRejectOffer() && !isPerformingAction">
        <div class="arrow"></div>
        <ul>
            <li class="reject-item" (click)="rejectOffer()">
                <img src="./assets/images/icons/x-circle.svg" alt="Reject">
                <span>{{ getActionButtonText('reject') }}</span>
            </li>
        </ul>
    </div>-->
</div>

<!-- Reject Confirmation Modal -->
<div class="confirmation-modal-overlay" *ngIf="showRejectModal" (click)="closeRejectModal()">
    <div class="confirmation-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer le refus</h3>
            <button class="close-button" (click)="closeRejectModal()">×</button>
        </div>
        <div class="modal-body">
            <p>Êtes-vous sûr de vouloir refuser cette offre ?</p>
            <p class="warning-text">Cette action ne peut pas être annulée.</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeRejectModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="confirmRejectOffer()">Refuser l'offre</button>
        </div>
    </div>
</div>